<script setup>
import { ref, defineProps } from 'vue';
import Popper from 'vue3-popper';

const icons = {
  copy: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M11.168 11.8906V14.1406C11.168 14.5546 10.832 14.8906 10.418 14.8906H3.91797C3.71906 14.8906 3.52829 14.8116 3.38764 14.671C3.24699 14.5303 3.16797 14.3395 3.16797 14.1406V5.64063C3.16797 5.22663 3.50397 4.89063 3.91797 4.89063H5.16797C5.50302 4.8904 5.83751 4.91805 6.16797 4.97329M11.168 11.8906H13.418C13.832 11.8906 14.168 11.5546 14.168 11.1406V7.89063C14.168 4.91729 12.006 2.44996 9.16797 1.97329C8.83751 1.91805 8.50302 1.8904 8.16797 1.89063H6.91797C6.50397 1.89063 6.16797 2.22663 6.16797 2.64063V4.97329M11.168 11.8906H6.91797C6.71906 11.8906 6.52829 11.8116 6.38764 11.671C6.24699 11.5303 6.16797 11.3395 6.16797 11.1406V4.97329M14.168 9.39063V8.14063C14.168 7.54389 13.9309 6.97159 13.509 6.54964C13.087 6.12768 12.5147 5.89063 11.918 5.89063H10.918C10.7191 5.89063 10.5283 5.81161 10.3876 5.67096C10.247 5.5303 10.168 5.33954 10.168 5.14063V4.14063C10.168 3.84515 10.1098 3.55257 9.9967 3.27959C9.88362 3.00661 9.71789 2.75857 9.50896 2.54964C9.30003 2.3407 9.05199 2.17497 8.77901 2.0619C8.50602 1.94882 8.21344 1.89063 7.91797 1.89063H7.16797" stroke="#6D7181" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>',
};

const popperStatus = ref('Copy');
const activePopper = ref({});
const icon = (type) => icons[type] || '';

defineProps({
  contact: {
    type: Object,
    default: () => {},
  },
});

const togglePopper = (index, status) => {
  activePopper.value[index] = status;
};

const copyToClipboard = async (value) => {
  try {
    await navigator.clipboard.writeText(value);
    popperStatus.value = 'Copied!';
    setTimeout(() => {
      popperStatus.value = 'Copy';
    }, 1500);
  } catch (err) {
    console.error('Cannot copy to clipboard:', err);
  }
};

const capitalizeName = (name) => {
  if (!name) return '';
  return name
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
</script>
<template>
  <div class="border-color-body-color w-full rounded-md border px-2 py-2">
    <template
      v-for="(value, label, idx) in {
        Name: capitalizeName(contact.name),
        Phone: contact.phone,
        Email: contact.email,
      }"
      :key="label"
    >
      <div class="text-left">
        <label class="text-2xs font-bold uppercase text-gray-over-dark">{{
          label
        }}</label>
        <div class="flex flex-row items-center justify-between pr-3">
          <p
            :class="{ truncate: label === 'Email' }"
            class="text-xs"
          >
            {{ value }}
          </p>

          <popper
            v-if="label === 'Email'"
            :show="activePopper[idx]"
            placement="top"
            :arrow="true"
            offset-distance="6"
            @click="copyToClipboard(value)"
            @mouseenter="togglePopper(idx, true)"
            @mouseleave="togglePopper(idx, false)"
          >
            <div
              class="cursor-pointer hover:rounded-sm hover:bg-light-gray"
              v-html="icon('copy')"
            />
            <template #content>
              <div
                class="hidden rounded-md bg-dark-gray p-1 text-light-gray shadow-md lg:block"
              >
                <p class="text-2xs">
                  {{ popperStatus }}
                </p>
              </div>
            </template>
          </popper>
        </div>
      </div>
    </template>
  </div>
</template>
